import React, { useState } from "react";
import "./Contactus.css";
import { apiService } from "../utils/api";
import Footer from "./Footer";

const Contactus = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [formStatus, setFormStatus] = useState({
    submitted: false,
    error: false,
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, email, phone, subject, message } = formData;

    if (!name || !email || !subject || !message) {
      setFormStatus({
        submitted: true,
        error: true,
        message: "Please fill in all required fields.",
      });
      return;
    }
    try {
      const res = await apiService.contactUs(formData);
      if (!res.data.success) {
        setFormStatus({
          submitted: true,
          error: true,
          message: res.data.message,
        });
        return;
      }
      setFormStatus({
        submitted: true,
        error: false,
        message: "Your message has been sent successfully.",
      });
    } catch (err) {
      setFormStatus({
        submitted: true,
        error: true,
        message: "Sorry, something went wrong. Please try again later.",
      });
      return;
    }

    // Reset form after submission
    setFormData({
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
    });
  };

  return (
    <div className="contact-container">
      <div className="contact-header">
        <h1>Contact Us</h1>
        <p>We'd love to hear from you. Reach out to us with any questions or inquiries.</p>
      </div>

      <div className="contact-content">
        <div className="contact-form-container">
          <h2>Send Us a Message</h2>
          {formStatus.submitted ? (
            <div className={`form-message ${formStatus.error ? "error" : "success"}`}>{formStatus.message}</div>
          ) : (
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required placeholder="Your full name" />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required placeholder="Your email address" />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} placeholder="Your phone number (optional)" />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} required placeholder="What is this regarding?" />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea id="message" name="message" value={formData.message} onChange={handleChange} required placeholder="Your message" rows="5"></textarea>
              </div>

              <button type="submit" className="submit-btn">
                Send Message
              </button>
            </form>
          )}
        </div>

        <div className="contact-info-container">
          <div className="contact-info">
            <h2>Contact Information</h2>
            <div className="info-item">
              <div className="info-icon">📍</div>
              <div className="info-content">
                <h3>Our Location</h3>
                <p>New Pitman's Institute India</p>
                <p>In between Netram Crossing, Prayagraj </p>
                <p>Uttar Pradesh, India - 211002</p>
              </div>
            </div>

            {/* <div className="info-item">
              <div className="info-icon">📞</div>
              <div className="info-content">
                <h3>Phone Numbers</h3>
                <p>Main Office: +91 </p>
                <p>Admissions: +91 </p>
                <p>Student Support: +91 </p>
              </div>
            </div> */}

            <div className="info-item">
              <div className="info-icon">✉️</div>
              <div className="info-content">
                <h3>Email Addresses</h3>
                {/* <p>General Inquiries: info@pitmans-institute.com</p>
                <p>Admissions: admissions@pitmans-institute.com</p> */}
                <p>Support: support@newpitmansinstituteindia.com</p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">🕒</div>
              <div className="info-content">
                <h3>Office Hours</h3>
                <p>Monday - Saturday: 9:00 AM - 6:00 PM</p>
                <p>Sunday: Closed</p>
              </div>
            </div>
          </div>

          <div className="map-container">
            <h3>Find Us On Map</h3>
            <div className="map-placeholder">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13639.482942259698!2d81.83390868715821!3d25.465854300000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399acbb6a777af4d%3A0x159fff5548f2b376!2sPitman&#39;s%20Steno%20Typing%20Institute!5e1!3m2!1sen!2sin!4v1747494897046!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                title="Google Maps"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      <div className="faq-section">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-grid">
          <div className="faq-item">
            <h3>What are your course durations?</h3>
            <p>Our courses range from 3 months to 1 year depending on the program and level of expertise you wish to achieve.</p>
          </div>
          <div className="faq-item">
            <h3>Do you offer online classes?</h3>
            <p>Yes, we offer both in-person and online classes to accommodate students from different locations.</p>
          </div>
          <div className="faq-item">
            <h3>How can I schedule a campus visit?</h3>
            <p>You can schedule a campus visit by calling our admissions office or filling out the contact form on this page.</p>
          </div>
          <div className="faq-item">
            <h3>Do you provide job placement assistance?</h3>
            <p>Yes, we have a dedicated placement cell that helps our students find suitable job opportunities after course completion.</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contactus;
